import { createFileRoute } from '@tanstack/react-router';
import { HealthMeasurementsScreen } from '../../screens/health/HealthMeasurements';

export const Route = createFileRoute('/health/measurements')({
  component: HealthMeasurementsScreen,
});
